document.addEventListener('DOMContentLoaded', () => {
  const forms = Array.from(document.querySelectorAll('form[action="/cart/add"]'));
  if (!forms.length) return;

  let pendingAddons = [];
  let addingAddons = false;

  const getSelectedAddons = (form) => {
    const addonWrap = form.querySelector('[data-pdp-addons]');
    if (!addonWrap) return [];

    const parentProduct = addonWrap.dataset.parentProduct || '';
    const parentHandle = addonWrap.dataset.parentHandle || '';

    return Array.from(form.querySelectorAll('.js-addon-toggle:checked[data-variant-id]'))
      .map((el) => ({
        id: Number(el.dataset.variantId),
        parentProduct,
        parentHandle,
        addonTitle: el.dataset.addonTitle || ''
      }))
      .filter((item) => item.id);
  };

  // Beim Klick auf Add-to-cart die aktuell ausgewählten Add-ons merken
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button[type="submit"][name="add"], .add-to-cart, button.add-to-cart');
    if (!btn) return;

    const form = btn.closest('form[action="/cart/add"]');
    if (!form) return;

    pendingAddons = getSelectedAddons(form);
  });

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const res = await originalFetch(...args);

    try {
      const url = args?.[0]?.toString?.() || '';
      const isCartAdd = url.includes('/cart/add');
      const isAddonRequest = url.includes('/cart/add.js');

      if (isCartAdd && pendingAddons.length && !addingAddons) {
        setTimeout(async () => {
          if (!pendingAddons.length) return;

          addingAddons = true;
          const addonsToAdd = pendingAddons;
          pendingAddons = [];

          try {
            await originalFetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: addonsToAdd.map((addon) => ({
                  id: addon.id,
                  quantity: 1,
                  properties: {
                    _pdp_addon: 'true',
                    _parent_product: addon.parentProduct,
                    _parent_handle: addon.parentHandle,
                    _addon_title: addon.addonTitle
                  }
                }))
              })
            });
          } catch (err) {
            console.error('Addon add error:', err);
          } finally {
            addingAddons = false;
          }

          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }, 150);
      }
    } catch (err) {
      console.error(err);
    }

    return res;
  };
});